// SPDX-License-Identifier: AGPL-3.0-or-later

import type {ValueOf} from '@fluxer/constants/src/ValueOf';

export const ScheduledEventEntityType = {
	VOICE: 2,
	EXTERNAL: 3,
} as const;

export type ScheduledEventEntityTypeValue = ValueOf<typeof ScheduledEventEntityType>;

export const ScheduledEventStatus = {
	SCHEDULED: 1,
	ACTIVE: 2,
	COMPLETED: 3,
	CANCELED: 4,
} as const;

export type ScheduledEventStatusValue = ValueOf<typeof ScheduledEventStatus>;

export const SCHEDULED_EVENTS_PER_GUILD_MAX = 50;
export const SCHEDULED_EVENT_NAME_MAX_LENGTH = 100;
export const SCHEDULED_EVENT_DESCRIPTION_MAX_LENGTH = 1000;
export const SCHEDULED_EVENT_LOCATION_MAX_LENGTH = 100;
